module.exports = __webpack_public_path__ + "static/media/10b_tn.7b99e827.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/10b_tn.jpg
// module id = 500
// module chunks = 0